<template>
  <div class="flex flex-row items-center space-x-12">
    <FormRadio
      v-for="(option, optionIndex) in _payload"
      :key="optionIndex"
      :value="option._checked"
      :label="option._label"
      @check="onCheck(option)"
    >
      <template
        v-if="$scopedSlots.check"
        #check="{ checked }"
      >
        <slot name="check" v-bind="{ checked, label: option._label }" />
      </template>
      <template
        v-if="$scopedSlots.default"
        #default="{ checked }"
      >
        <slot v-bind="{ checked, label: option._label }" />
      </template>
    </FormRadio>
  </div>
</template>

<script>
import uniqid from 'uniqid';
import cloneDeep from 'lodash.clonedeep';
import FormRadio from '@/components/Form/FormRadio.vue';

export default {
  name: 'FormRadioGroup',
  components: {
    FormRadio,
  },
  props: {
    value: {
      default: null,
    },
    options: {
      type: Array,
      default: () => [],
    },
    keyBy: {
      type: [Function, String],
      default: 'value',
    },
    labelBy: {
      type: [Function, String],
      default: 'label',
    },
  },
  data() {
    return {
      name: uniqid(),
    };
  },
  computed: {
    _payload() {
      return cloneDeep(this.options).map((option) => {
        if (typeof this.labelBy === 'function') {
          // eslint-disable-next-line no-param-reassign
          option._label = this.labelBy(option);
        } else {
          // eslint-disable-next-line no-param-reassign
          option._label = option[this.labelBy];
        }
        if (typeof this.keyBy === 'function') {
          // eslint-disable-next-line no-param-reassign
          option._checked = this.value === this.keyBy(option);
        } else {
          // eslint-disable-next-line no-param-reassign
          option._checked = this.value === option[this.keyBy];
        }
        return option;
      });
    },
  },
  methods: {
    onCheck(option) {
      if (typeof this.keyBy === 'function') {
        this.$emit('input', this.keyBy(option));
      } else {
        this.$emit('input', option[this.keyBy]);
      }
    },
  },
};
</script>
